/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit
} from '@angular/core';
import { VisibilityService } from '../../../../../services/visibility.service';
import { AppService } from '../../../../../services/app-service';
import { Observable } from 'rxjs';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';

@Component({
  selector: 'app-developer-apps',
  templateUrl: './app-developer-apps.component.html',
  styleUrls: ['./app-developer-apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDeveloperAppsComponent implements OnInit, OnChanges {
  @Input()
  appId: string;

  @Input()
  developerName: string;

  @Input()
  appStore: string;

  @Input()
  device: string;

  @Input()
  region: string;

  @Input()
  month: string;

  @Input()
  limit = 30;

  @Input()
  showHeading = false;

  @Input()
  logoOnly = false;

  @Input()
  colClass = 'col-lg-4 col-md-6 col-12';

  @Input()
  hidePagination = false;

  loadingApps = true;
  developerApps = [];
  totalItems = 0;

  tablet$: Observable<boolean>;

  constructor(
    private _appService: AppService,
    private _changeDetector: ChangeDetectorRef,
    private _element: ElementRef,
    private _mediaQueryService: MediaQueryService,
    private _visibilityService: VisibilityService
  ) {}

  ngOnInit(): void {
    this.tablet$ = this._mediaQueryService.lt(Breakpoint.lg);
  }

  ngOnChanges(): void {
    if (this.tablet$) {
      this.loadDeveloperApps();
    } else {
      void this._visibilityService
        .isVisible(this._element.nativeElement)
        .then(response => {
          if (response) {
            this.loadDeveloperApps();
          }
        });
    }
  }

  loadDeveloperApps(startIndex = 0) {
    const appLimit = this.hidePagination ? this.limit + 1 : this.limit;
    void this._appService
      .searchForApps(
        startIndex,
        appLimit,
        `appStore=${this.appStore}&device=${this.device}&region=${this.region}&sortBy=inventory%20DESC&developerName=${this.developerName}`
      )
      .then((response: any) => {
        if (
          response.numFound > 0 &&
          response.docs &&
          response.docs.length > 0
        ) {
          this.totalItems = response.numFound;
          this.developerApps = response.docs.filter(
            app => app.appId !== this.appId
          );
          if (this.hidePagination) {
            if (this.developerApps.length > this.limit) {
              this.developerApps.pop();
            }
            this.totalItems = this.developerApps.length;
          }
        }
        this.loadingApps = false;
        this._changeDetector.detectChanges();
      });
  }
}
